import react from 'react';
import './App.css';
import Container from './Container';


function App() {
  return (
    <div className="App">
        <Container />
    </div>
  );
}

export default App;
